import * as Icons from 'styled-cssgg';
export default Icons;
